import Pagination from "@/shared/Pagination";
import { Card, ContentList } from "./styles";
import { getImages } from "../helpers";
import OnexOneRecipe from "@/widgets/Nota/Templates/OnexOneRecipe";
import OnexOne from "@/widgets/Nota/Templates/OnexOne";
import { Fragment } from "react";
import Banner from "@/widgets/Banner/Templates/Banner";
import { ListStyleGeneric } from "./../styleGenericList";
import { ContainerAutoList } from "@/shared/ContainerAutoList";
import { BannerCajaGris } from "@/shared/ContentBanner";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

const Listado4Columns = (props) => {

  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};
  // si no tengo props, busco contexto
  if(Object.keys(props).length === 0 && !!formatContent) {
        props = { 
            ...props,
            ...formatContent?.listado,
        };
  } 

  const {
    result,
    pagination,
    positionBanner = [2, 9, 16, 23],
    getContentOnexOne,
    iconMultimedia = "",
    withPaginate = true
  } = props;

  let slotIdCount = 0;

  /* const filterSizeBanner = (slot, sizeBanner) => {
    let slotId = "caja"+slot
    let size = sizeBanner[Object.keys(sizeBanner).filter(item => (item == slotId))]
    return size;
  } */

  const COMPONENT_MAP = {
    recipe: OnexOneRecipe,
    default: OnexOne,
  };

  const selectComponentOnexOne = (element) => {
    const authorType = element?.type;
    return COMPONENT_MAP[authorType] || COMPONENT_MAP.default;
  };

  return (
    <ListStyleGeneric className="list-x4">
      <ContainerAutoList>
        <ContentList>
          {result?.map((element, index) => {
            const ComponentOnexOne = selectComponentOnexOne(element);
            return (
              <Fragment key={`nota ${index}`}>
                <Card>
                  <ComponentOnexOne
                    {...element}
                    author={element.authors}
                    images={getImages(element)}
                    cutTitle={true}
                    showDate={true}
                    image={element.thumbnail}
                    iconMultimedia={iconMultimedia}
                  >
                    {getContentOnexOne && getContentOnexOne(element)}
                  </ComponentOnexOne>
                </Card>
                {positionBanner.includes(index) && (
                  <Card className={`bannerList nota${index} ${slotIdCount++}`} key={`nota ${index}`}>
                    <BannerCajaGris className={`bannerCajaGris ${slotIdCount}`}>
                    {/* {filterSizeBanner(slotIdCount,sizeBanner) ? <BannerLazy slotId={`caja${slotIdCount}`} adsPath={adsPath} mapping={filterSizeBanner(slotIdCount,sizeBanner)} /> : } */}
                      <Banner slotId={`caja${slotIdCount}`} />
                    </BannerCajaGris>
                  </Card>
                )}
              </Fragment>
            )
          })}
        </ContentList>
        {withPaginate &&
          <Pagination
            limit={pagination.limit}
            offset={pagination.offset}
            total={pagination.total <= 230 ? pagination.total : 230}
          />
        }
      </ContainerAutoList>
    </ListStyleGeneric>
  );
};

export default Listado4Columns;
